import React from 'react';
import { graphql } from 'gatsby';
import { useTranslation } from 'react-i18next';

import Layout from '@/components/Layout';
import ServiceHero from '@/components/ServiceHero';
import ServiceLinkItem from '@/components/ServiceLinkItem';

import { SERVICE_UXUI } from '@/referentials/routes';

export default function DevelopmentBackFrontPage({ data }) {
  const { t } = useTranslation();

  const contentDev = {
    name: t('devTitle'),
    bg: 'bg-yellow',
    blobFirstColor: '#F0C798',
    blobSecondColor: '#FED29F',
    content: t('devContent'),
    nextPage: t('devNextPage'),
    tags: [t('tagWebsite'), t('tagApi'), t('tagMobile'), t('tagDevOps')],
  };

  return (
    <Layout
      title="Services: Developpement back et front end"
      description="Le charrette.club design, code et fait grandir des produits digitaux innovants."
      className="mt-8"
    >
      <ServiceHero tags={contentDev} img={data.tools} />
      <ServiceLinkItem
        title={`${t('next')} ${contentDev.nextPage}`}
        to={SERVICE_UXUI}
      />
    </Layout>
  );
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: {
        ns: { in: ["services", "general"] }
        language: { eq: $language }
      }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    tools: file(relativePath: { eq: "dev.webp" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
  }
`;
